import React from "react"
import "./work.scss"

import Layout from "../components/layout"
import WorkEntry from "../containers/work_entry"
import ProjectEntry from "../containers/project_entry"
import SEO from "../components/seo"

import SelfieImage from "../images/capture.gif"
import LightingDemoImage from "../images/lighting_demo.gif"
import VendingDemoImage from "../images/vending_machine.png"
import TelephoneImage from "../images/telephone.png"
import VoiceAssistantImage from "../images/voice_assistant.jpeg"
import FaceDetectorImage from "../images/face_detector.jpg"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSquareFull } from "@fortawesome/free-solid-svg-icons"

const workExperiences = [
  {
    date: "Jul 2021 - Present",
    position: "Software Engineering Intern",
    company: "Palantir Technologies",
    location: "Palo Alto, California",
    description:
      "Currently on the Graphs team, working on an application displaying data and relationships as nodes and links with expressive tooling for graph exploration and node discovery.",
  },
  {
    date: "May 2021 - Jul 2021",
    position: "Software Engineering Intern",
    company: "Stripe",
    location: "Singapore",
    description:
      "Part of the APAC Payment Methods team, focusing on maintaining observability across all digital wallets supported by Stripe in Asia.",
  },
  {
    date: "Aug 2020 - Nov 2020",
    position: "Software Engineering Intern",
    company: "GovTech",
    location: "Singapore",
    description:
      "Worked on SupplyAlly, Singapore’s centralized distribution system that was used to distribute TraceTogether tokens. Both frontend and backend.",
  },
  {
    date: "Apr 2020 - Aug 2020",
    position: "Software Engineering Intern",
    company: "Picovoice",
    location: "Vancouver, Canada",
    description:
      "Worked with web browser technologies and web frameworks to create voice-enabled web pages",
  },
  {
    date: "Jun 2019 - Aug 2019",
    position: "Software Engineering Intern",
    company: "Accenture",
    location: "Singapore",
    description: "Developed IoT and voice-enabled products",
  },
]

const schoolExperience = [
  {
    date: "Aug 2017 - (Dec 2021)",
    position: "Renaissance Engineering Programme",
    company: "Nanyang Technological University",
    location: "Singapore",
    description:
      "The Renaissance Engineering Programme is a premier scholars programme in NTU, characterised by the awarding of a Bachelor of Engineering Science coupled with a Master of Science in Technology Management.",
  },
  {
    date: "Aug 2019 - May 2020",
    position: "Computer Science Major",
    company: "University of California, Berkeley",
    location: "California, US",
    description:
      "Spent a year at the UC Berkeley taking Computer Science Courses. Started a competitive Kaggle team under the DataBears Also did a solo trip along the west coast :D",
  },
]

const WorkPage = () => (
  <Layout>
    <SEO title="Work" />
    <div className="work">
      <div className="section-title">
        <FontAwesomeIcon icon={faSquareFull} color="#1368f0" />
        <span className="name"> Experience</span>
      </div>
      {workExperiences.map(experience => {
        return <WorkEntry {...experience} />
      })}
      <div className="section-title">
        <FontAwesomeIcon icon={faSquareFull} color="#1368f0" />
        <span className="name"> School</span>
      </div>
      {schoolExperience.map(experience => {
        return <WorkEntry {...experience} />
      })}
    </div>
  </Layout>
)

export default WorkPage
